

















import {Component, Mixins} from 'vue-property-decorator'
import ModalBase from '../ModalBase.vue'
import modalBaseMixin from '@/mixins/modal/modalBaseMixin'
import {IModal, Modal, Status} from "@/entities";
// steps
const ModalPaymentResultPlan = () => import('./ModalPaymentResultPlan.vue')
const ModalPaymentResultSuccess = () => import('./ModalPaymentResultSuccess.vue')
const ModalPaymentResultError = () => import('./ModalPaymentResultError.vue')
const ModalPaymentResultEarly = () => import('./ModalPaymentResultEarly.vue')
const ModalPaymentResultPaid = () => import('./ModalPaymentResultPaid.vue')

@Component({
  name: 'ModalPaymentResult',
  components: {
    ModalBase,
    ModalPaymentResultPlan,
    ModalPaymentResultSuccess,
    ModalPaymentResultError,
    ModalPaymentResultEarly,
    ModalPaymentResultPaid
  }
})
export default class ModalPaymentResult extends Mixins(modalBaseMixin) {

  protected getModal(initSubject: any, initStep?: string): IModal {
    return new Modal({
      name: () => this.$t('modals.titles.base') as string,
      close: this.close,
      stepName: initStep,
      subject: initSubject,
      steps: [
        {
          name: 'success',
          controls: [
            {
              type: 'ok',
              label: 'awesome'
            }
          ]
        }, {
          name: 'error',
          controls: [
            {
              type: 'ok'
            }
          ]
        }, {
          name: 'early',
          controls: [
            {
              type: 'ok'
            }
          ]
        }, {
          name: 'paid',
          controls: [
            {
              type: 'ok'
            }
          ]
        }
      ]
    });
  }

  private close(): void {
    this.$storage.actions.closeModal();
    this.$router.push(this.$route.path);
  }

  get mappedStatus(): Status | undefined {
    switch (this.modal.currentStep?.name) {
      case 'success':
      case 'paid':
        return 'success';
      case 'error':
        return 'danger';
      default:
        return undefined;
    }
  }

}
